export var TemporaryStorageOption;
(function (TemporaryStorageOption) {
    TemporaryStorageOption["MEMORY"] = "memory";
    TemporaryStorageOption["FILESYSTEM"] = "file";
})(TemporaryStorageOption || (TemporaryStorageOption = {}));
//# sourceMappingURL=options.js.map